(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7871],{

/***/ 36924:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[slug]",
      function () {
        return __webpack_require__(42195);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ADDITIONAL_PAGE_TYPE; },
/* harmony export */   "y": function() { return /* binding */ LAYOUT_TYPE; }
/* harmony export */ });
var ADDITIONAL_PAGE_TYPE = {
    BLOG: "blog",
    NEW_BLOG: "NewBlog",
    TESTIMONIAL: "testimonial",
    HOME: "home",
    NEW_TESTIMONIALS: "Testimonials"
};
var LAYOUT_TYPE = {
    GRID: "grid",
    CAROUSEL: "carousel"
};


/***/ }),

/***/ 59108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_themeImports__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53978);
/* harmony import */ var _dotpe_additional_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(531);
/* harmony import */ var _utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98616);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20155);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_ListPresentation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65975);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26061);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26910);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16902);













var AdditionalPage = function(props) {
    var getBlogProps = function getBlogProps(widgetData) {
        var updatedBlogData = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.cloneDeep)(widgetData);
        var listPresentation = updatedBlogData.listPresentation;
        listPresentation.textAlign = "center";
        listPresentation.numColumnsDesktop = 3;
        listPresentation.numColumnsMobile = 2;
        listPresentation.layoutType = _constant__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT_TYPE.GRID */ .y.GRID;
        return updatedBlogData;
    };
    var getTestimonialData = function getTestimonialData(testimonialData) {
        var ref;
        var updatedTestimonialData = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.cloneDeep)(testimonialData);
        var shouldUseL2 = ((ref = updatedTestimonialData.listPresentation) === null || ref === void 0 ? void 0 : ref.layoutName) === src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_10__/* .TESTIMONIAL_LAYOUT_TYPES.FOUR */ .b_.FOUR;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, updatedTestimonialData), {
            listPresentation: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, updatedTestimonialData.listPresentation), {
                layoutType: _constant__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT_TYPE.GRID */ .y.GRID
            }), shouldUseL2 ? {
                layoutName: src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_10__/* .TESTIMONIAL_LAYOUT_TYPES.TWO */ .b_.TWO
            } : {}),
            cardFrame: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, updatedTestimonialData.cardFrame, shouldUseL2 ? {
                authorImagePosition: src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_10__/* .TESTIMONIAL_IMAGE_POSITION.WITH_AUTHOR_INFO */ .eu.WITH_AUTHOR_INFO
            } : {})
        });
    };
    var renderTestimonialPage = function renderTestimonialPage() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DesignSystem_Widgets2_0_ListPresentation__WEBPACK_IMPORTED_MODULE_6__["default"], {
            widgetOptions: getTestimonialData(newTestimonialData === null || newTestimonialData === void 0 ? void 0 : newTestimonialData.props),
            isTestimonialListingPage: true
        });
    };
    var renderBlogAndTestimonialPage = function renderBlogAndTestimonialPage() {
        if (isNewBlogWidget) {
            return renderNewBlogWidgetComp();
        }
        return renderTestimonialPage();
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            catalogCategories: state.catalogReducer.categories,
            widgetData: state.additionalPagesReducer.additionalPageList,
            widgetInfo: state.jsonWidgetsReducer.widgets
        };
    }), storeInfo = ref13.storeInfo, catalogCategories = ref13.catalogCategories, widgetData = ref13.widgetData, widgetInfo = ref13.widgetInfo;
    var isMobile = (0,src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_9__/* .isMobileDevice */ .s)();
    var isHomePage = props.source === _constant__WEBPACK_IMPORTED_MODULE_8__/* .ADDITIONAL_PAGE_TYPE.HOME */ .Q.HOME;
    var newBlogWidgetData = (ref = Object.values(widgetInfo)) === null || ref === void 0 ? void 0 : ref.find(function(data) {
        return (data === null || data === void 0 ? void 0 : data.name) === _constant__WEBPACK_IMPORTED_MODULE_8__/* .ADDITIONAL_PAGE_TYPE.NEW_BLOG */ .Q.NEW_BLOG;
    });
    var newTestimonialData = (ref1 = Object.values(widgetInfo)) === null || ref1 === void 0 ? void 0 : ref1.find(function(data) {
        return (data === null || data === void 0 ? void 0 : data.name) === _constant__WEBPACK_IMPORTED_MODULE_8__/* .ADDITIONAL_PAGE_TYPE.NEW_TESTIMONIALS */ .Q.NEW_TESTIMONIALS;
    });
    var isNewBlogWidget = newBlogWidgetData && ((ref2 = props._addPage) === null || ref2 === void 0 ? void 0 : ref2.structure_type) !== 0 && ((ref3 = props._addPage) === null || ref3 === void 0 ? void 0 : ref3.page_type) === _constant__WEBPACK_IMPORTED_MODULE_8__/* .ADDITIONAL_PAGE_TYPE.BLOG */ .Q.BLOG;
    var isTestimonialPage = ((ref4 = props._addPage) === null || ref4 === void 0 ? void 0 : ref4.page_type) === _constant__WEBPACK_IMPORTED_MODULE_8__/* .ADDITIONAL_PAGE_TYPE.TESTIMONIAL */ .Q.TESTIMONIAL && newTestimonialData;
    var isBlogOrTestimonialPage = isNewBlogWidget || isTestimonialPage;
    // const [widgetData, setWidgetData] = useState({}); // if props.source is home then use widgetdata to render
    var _renderUnstructuredPageData = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: props === null || props === void 0 ? void 0 : (ref = props._addPage) === null || ref === void 0 ? void 0 : ref.html_data
            }
        });
    };
    var renderNewBlogWidgetComp = function() {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DesignSystem_Widgets2_0_ListPresentation__WEBPACK_IMPORTED_MODULE_6__["default"], {
            widgetOptions: getBlogProps(newBlogWidgetData === null || newBlogWidgetData === void 0 ? void 0 : newBlogWidgetData.props),
            blogData: props === null || props === void 0 ? void 0 : (ref = props._addPage) === null || ref === void 0 ? void 0 : (ref1 = ref.json_data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.blog) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.users_list) === null || ref3 === void 0 ? void 0 : ref3.list,
            isBlogListingPage: true,
            overrides: {
                layout: {
                    styles: {
                        background: ""
                    }
                }
            }
        });
    };
    var _renderStructuredPageData = function() {
        var ref;
        var dataToRender = (props === null || props === void 0 ? void 0 : (ref = props._addPage) === null || ref === void 0 ? void 0 : ref.json_data) || {};
        if (isHomePage) {
            // if the source is home then  use state because on home there can be multiple widgets
            dataToRender = (widgetData === null || widgetData === void 0 ? void 0 : widgetData.json_data) || {};
        }
        return dataToRender ? !!Object.keys(dataToRender).length && Object.keys(dataToRender).map(function(template) {
            var ref, ref1;
            var CompJSX = (0,_dotpe_additional_pages__WEBPACK_IMPORTED_MODULE_3__/* .AddPagesLib */ .qU)(template);
            var templateData = dataToRender[template];
            if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.max_items) templateData["max_items"] = props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.max_items;
            if (props.slug) templateData["slug"] = props.slug;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompJSX, {
                section: dataToRender[template],
                templateId: template,
                source: "cfe",
                onElementClick: function() {}
            }, template);
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            !isHomePage && ((ref5 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_4__/* .specificThemeRender */ .t)(storeInfo)) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.components) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Header) === null || ref7 === void 0 ? void 0 : ref7.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                    storeData: storeInfo,
                    categories: catalogCategories || []
                }, layout));
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(isTestimonialPage ? "tw-flex tw-flex-col ".concat(isMobile ? "tw-mt-[20px]" : "") : "additional--wrapper", " ").concat((props === null || props === void 0 ? void 0 : (ref8 = props.config) === null || ref8 === void 0 ? void 0 : ref8.max_items) ? "home-page" : ""),
                children: [
                    !isBlogOrTestimonialPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "additional-main",
                        children: ((ref9 = props._addPage) === null || ref9 === void 0 ? void 0 : ref9.structure_type) === 0 ? _renderUnstructuredPageData() : _renderStructuredPageData()
                    }) : renderBlogAndTestimonialPage(),
                    !isHomePage && ((ref10 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_4__/* .specificThemeRender */ .t)(storeInfo)) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.components) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Footer) === null || ref12 === void 0 ? void 0 : ref12.map(function(layout) {
                        return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                            storeData: storeInfo,
                            categories: catalogCategories || []
                        }, layout));
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AdditionalPage);


/***/ }),

/***/ 42195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _containers_AdditionalPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59108);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63896);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);







var AdditionalPageContainer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var advCustomSeo = props.advCustomSeoDetails;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : (ref = advCustomSeo.title) === null || ref === void 0 ? void 0 : ref.value) || "".concat(props === null || props === void 0 ? void 0 : (ref1 = props._addPage) === null || ref1 === void 0 ? void 0 : ref1.page_name, " - ").concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.name),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.logo_image,
        metaDescription: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : advCustomSeo.description) || "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        OGTitle: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : (ref4 = advCustomSeo.og_title) === null || ref4 === void 0 ? void 0 : ref4.value) || null,
        OGDescription: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : advCustomSeo.og_description) || null,
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_AdditionalPage__WEBPACK_IMPORTED_MODULE_2__["default"], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AdditionalPageContainer);


/***/ }),

/***/ 98616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,9990,212,7997,1023,8338,6664,8580,531,8673,7229,9819,6076,1305,9871,9252,4369,3896,9129,5975,9774,2888,179], function() { return __webpack_exec__(36924); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);